function getHeight(elem) {
	return elem.getBoundingClientRect().height;
}

function getOuterHeight(elem) {
	let elHeight = elem.getBoundingClientRect().height;
	elHeight += parseInt(window.getComputedStyle(elem).getPropertyValue('margin-bottom'), 10);

	return elHeight;
}

function getInnerHeight(elem) {
	let elHeight = elem.getBoundingClientRect().height;
	elHeight -= parseInt(window.getComputedStyle(elem).getPropertyValue('margin-bottom'), 10);

	return elHeight;
}

function changeHeight(el, height) {
	if (el.classList.contains('is-visible')) {
		el.style.height = `${height}px`;
	} else {
		el.style.height = 0;
	}
}

function close(dropdownBtn) {
	const dropdownContent = dropdownBtn.parentNode.querySelector('.dropdown__content');
	const contentHeight = dropdownContent ? getHeight(dropdownContent) : null;
	const parent = dropdownContent ? dropdownContent.parentNode : null;

	if (parent) {
		parent.classList.remove('is-visible');
		dropdownBtn.classList.remove('is-active');
	}

	if (contentHeight) {
		changeHeight(parent, contentHeight);
	}
}

function toggleClass(dropdownBtn) {
	const dropdownContent = dropdownBtn.parentNode.querySelector('.dropdown__content');
	const parent = dropdownContent.parentNode;
	const contentHeight = getHeight(dropdownContent);
	const submenu = dropdownBtn.classList.contains('service__side-subtitle');

	dropdownBtn.classList.toggle('is-active');
	parent.classList.toggle('is-visible');

	if (submenu) {
		const submenuParent = dropdownContent.parentNode.parentNode.closest('.service__side-submenu-list');
		const submenuContentHeight = getOuterHeight(submenuParent);
		const submenuContentHeightClose = getInnerHeight(submenuParent);

		changeHeight(parent, contentHeight);

		if (dropdownBtn.classList.contains('is-active')) {
			changeHeight(submenuParent, submenuContentHeight + contentHeight);
		} else {
			changeHeight(submenuParent, submenuContentHeightClose - contentHeight);
		}
	} else {
		changeHeight(parent, contentHeight);
	}
}

function checkEcoInitiate(el) {
	let elLabel = el.querySelector('.dropdown-js span.active');
	let regex = new RegExp('экоинициатива', 'i');

	return regex.test(elLabel.textContent);
}

function replaceActiveLabel(formDropdown, targetLable) {
	const allLabel = formDropdown.querySelectorAll('label');

	allLabel.forEach((el) => {
		el.classList.remove('is-active');
	});

	targetLable.classList.add('is-active');

	let isEco = checkEcoInitiate(formDropdown);

	if (isEco) {
		formDropdown.closest('.form').querySelector('.form .form__input-checkbox').classList.add('checked');
	} else {
		formDropdown.closest('.form').querySelector('.form .form__input-checkbox').classList.remove('checked');
	}
}

function replacePlaceHolder(e) {
	const formDropdown = e.target.closest('.form__item');
	const btn = formDropdown.querySelector('.dropdown-js');
	const targetLable = e.target;
	const input = formDropdown.querySelector('input');

	formDropdown.querySelectorAll('label').forEach((el) => {
		el.classList.remove('is-active');
	});

	e.target.classList.add('is-active');
	input.value = e.target.dataset.id;
	input.dispatchEvent(new Event('change'));

	btn.querySelector('span').textContent = e.target.dataset.name;
	btn.querySelector('span').classList.add('active');

	// btn.click();

	replaceActiveLabel(formDropdown, targetLable);
}

function init() {
	window.addEventListener('click', (e) => {
		const dropdownBtn = e.target.closest('.dropdown-js');
		if (dropdownBtn || e.target.classList.contains('dropdown-js')) {
			toggleClass(dropdownBtn);
		} else if (document.querySelector('.dropdown-js')) {
			document.querySelectorAll('.dropdown-js').forEach((el) => {
				close(el);
			});
		}

		if (e.target.classList.contains('dropdown-input')) {
			replacePlaceHolder(e);
		}
	});
}

export default {
	init,
	toggleClass,
};
